module.exports = __webpack_public_path__ + "static/img/c5-tallking.935ca6e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatars/c5-tallking.gif
// module id = 25
// module chunks = 0